export const VIDEO_SERVER_REQ_ENDPOINT = `https://www.myfreecams.com/modeldirector`
export const BROADCASTER_WRAPPER_ID = 'broadcaster-wrapper'
export const BROADCASTER_CONTAINER_ID = 'broadcaster-container'

export const CLASS_BROADCASTER_CONTAINER_OVERRIDE =
    'broadcaster-container-override'
export const CLASS_BROADCASTER_SETTINGS_VISIBLE =
    'broadcaster-publisher-settings-visible'
// the host box sizes the video (create form, the owner's room) instead of the floater's fixed heights
export const CLASS_BROADCASTER_CONTAINER_HOST = 'broadcaster-container-host'

export type BroadcasterHost = 'floater' | 'form' | 'room'

export enum BROADCASTING_STATE {
    UNINITIALIZED = 'UNINITIALIZED',
    NOT_AVAILABLE = 'NOT_AVAILABLE',
    INITIALIZING = 'INITIALIZING',
    ERROR = 'ERROR',
    OFF = 'OFF',
    ON = 'ON',
}
